import Vue from 'vue'
import Vuex from 'vuex'
import dexie from '@/utils/dexie'
import * as general from '@/utils/general'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    settings: [],
    statusMessage: {
      text: '',
      css: '',
      spinner: false
    },
    manifestLoaded: false,
    players: [],
    cacheNodeTotals: {},
    refreshingPlayers: [],
    fetchOptions: {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8',
        'X-API-Key': 'e43e3a13a2b54560bde9811073c06415'
      }
    },
    debugMessage: ''
  },
  mutations: {
    updatePlayer(state, player) {
      //state.players[player.id] = player;
      //Vue.set(state.players, player.id, player);
      let oldPlayers = state.players;
      state.players = [];
      let found = false;
      oldPlayers.forEach(element => {
        if (element.key != player.key) {
          state.players.push(element);
          dexie.players.put(element);
        } else {
          state.players.push(player);
          dexie.players.put(player);
          found = true;
        }
      });
      if (!found) {
        state.players.push(player);
        dexie.players.put(player);
      }
      general.updatePlayerRouter();
    },
    removePlayer(state, key) {
      let oldPlayers = state.players;
      state.players = [];
      for (const player of oldPlayers) {
        if (player.key !== key) {
          state.players.push(player);
          dexie.players.put(player);
        }
      }
      general.debug('players', state.players);
      general.updatePlayerRouter();
    },
  },
  actions: {
    
  },
  modules: {
  }
})
